<template>
  <v-card>
    <v-card-title class="align-start">
      <span class="font-weight-semibold text-base">Statistiques</span>
    </v-card-title>
    <loader v-if="loading" />
    <v-card-text v-else>
      <v-row>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiCurrencyEur }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">CA</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ ca.value }}</span
                  >
                </template>
                <span>{{ ca.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiSpeedometer }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">RPM</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ rpm.value }}</span
                  >
                </template>
                <span>{{ rpm.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiMonitorEye }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">Vues</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ views.value }}</span
                  >
                </template>
                <span>{{ views.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiFormatRotate90 }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">Sessions</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ sessions.value }}</span
                  >
                </template>
                <span>{{ sessions.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="primary" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiMonitorCellphone }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">Coût Moyen / article</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ avgCost.value }}</span
                  >
                </template>
                <span>{{ avgCost.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>
      <!-- Republishing -->
      <v-row>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="#fb9e0b" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiCurrencyEur }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">CA Republication</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ caRep.value }}</span
                  >
                </template>
                <span>{{ caRep.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="#fb9e0b" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiSackPercent }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">% CA Republication</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ caRepPercent.value }}</span
                  >
                </template>
                <span>{{ caRepPercent.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="#fb9e0b" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiFormatRotate90 }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">Sessions Republication</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ sessionsRep.value }}</span
                  >
                </template>
                <span>{{ sessionsRep.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="#fb9e0b" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiPercent }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">% Sessions Republication</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ sessionsRepPercent.value }}</span
                  >
                </template>
                <span>{{ sessionsRepPercent.raw }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
        <v-col cols="6" lg="2" md="4">
          <div class="d-flex">
            <v-avatar size="44" color="#fb9e0b" rounded class="elevation-1">
              <v-icon dark color="white" size="30">
                {{ icons.mdiBook }}
              </v-icon>
            </v-avatar>
            <div class="ms-3">
              <p class="text-xs mb-0">nb republiés / total</p>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <span
                    class="text--primary text-xl font-weight-bold"
                    v-on="on"
                    v-bind="attrs"
                    >{{ counts.rep_counts }} / {{ counts.total_counts }}</span
                  >
                </template>
                <span>{{ counts.rep_counts }} / {{ counts.total_counts }}</span>
              </v-tooltip>
            </div>
          </div>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import {
  mdiSpeedometer,
  mdiMonitorCellphone,
  mdiMonitorEye,
  mdiCurrencyEur,
  mdiFormatRotate90,
  mdiSackPercent,
  mdiPercent,
  mdiBook,
} from "@mdi/js";
import {
  formatNumberCompact,
  formatCurrencyCompact,
  formatPercent,
} from "@/utils/formatting";

import Loader from "@/components/common/Loader";

export default {
  name: "TopStatsCard",
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    Loader,
  },
  data() {
    return {
      icons: {
        mdiSpeedometer,
        mdiMonitorCellphone,
        mdiMonitorEye,
        mdiCurrencyEur,
        mdiFormatRotate90,
        mdiSackPercent,
        mdiPercent,
        mdiBook,
      },
      ca: {
        value: 0,
        raw: 0,
      },
      views: {
        value: 0,
        raw: 0,
      },
      sessions: {
        value: 0,
        raw: 0,
      },
      rpm: {
        value: 0,
        raw: 0,
      },
      avgCost: {
        value: 0,
        raw: 0,
      },
      caRep: {
        value: 0,
        raw: 0,
      },
      caRepPercent: {
        value: 0,
        raw: 0,
      },
      sessionsRep: {
        value: 0,
        raw: 0,
      },
      sessionsRepPercent: {
        value: 0,
        raw: 0,
      },
      counts: {
        rep_counts: 0,
        total_counts: 0,
      },
    };
  },
  computed: {
    statsForPeriod() {
      return this.$store.getters["audience/getRentaGlobalStats"];
    },
  },
  watch: {
    statsForPeriod() {
      this.caRep.raw = this.statsForPeriod.republishing_ca;
      this.caRep.value = formatCurrencyCompact(this.caRep.raw);
      this.caRepPercentCalcul =
        (this.statsForPeriod.republishing_ca / this.statsForPeriod.total_ca) *
        100;
      this.caRepPercent.raw = formatNumberCompact(this.caRepPercentCalcul, 2);
      this.caRepPercent.value = `${this.caRepPercentCalcul.toFixed(2)} %`;
      this.sessionsRep.raw = this.statsForPeriod.republishing_sessions;
      this.sessionsRep.value = formatNumberCompact(this.sessionsRep.raw);
      this.sessionsRepCalcul =
        (this.statsForPeriod.republishing_sessions /
          this.statsForPeriod.total_sessions) *
        100;
      this.sessionsRepPercent.raw = formatNumberCompact(
        this.sessionsRepCalcul,
        2
      );
      this.sessionsRepPercent.value = `${this.sessionsRepCalcul.toFixed(2)} %`;
      this.ca.raw = this.statsForPeriod.total_ca;
      this.ca.value = formatCurrencyCompact(this.ca.raw);
      this.views.raw = this.statsForPeriod.total_views;
      this.views.value = formatNumberCompact(this.views.raw);
      this.sessions.raw = this.statsForPeriod.total_sessions;
      this.sessions.value = formatNumberCompact(this.sessions.raw);
      this.rpmcalcul = (this.ca.raw / this.sessions.raw) * 1000;
      this.rpm.raw = `${this.rpmcalcul.toFixed(2)}€`;
      this.rpm.value = this.rpm.raw;
      this.avgCost.raw = formatCurrencyCompact(
        this.statsForPeriod.average_price
      );
      this.avgCost.value = this.avgCost.raw;
      this.counts.rep_counts = this.statsForPeriod.republishing_count;
      this.counts.total_counts = this.statsForPeriod.total_posts;
    },
  },
};
</script>

<style scoped></style>
